// Sources follow the page convention loswp--<element>--<surface> and are capped at 64 chars by
// the clicks API. A source never identifies the arm — every readout joins on the test's bucketing.
export const IMPRESSION_SOURCE = 'loswp--pack-pitch--impression';
export const PACK_CLICK_SOURCE = 'loswp--pack-trial-button--preview-gate';
export const PDF_CLICK_SOURCE = 'loswp--download-only-button--preview-gate';

// Attribution tag carried onto the checkout URL, distinct from the tabs hero's so this test's
// checkout visits are separable. Api::V0::RegistrationsController must recognise it for the
// abandon-checkout recovery to apply.
export const CHECKOUT_TRIGGER = 'loswp-preview-gate';
